import React, { useState } from "react";
import { useSettings } from "../context/SettingsContext";

export default function AmenitiesSection() {
  const { amenities } = useSettings();
  const [hover, setHover] = useState(null);

  return (
    <section className="py-28 lg:py-36 bg-[#EBE0CE] relative overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <div className="section-eyebrow mb-4">Curated Amenities</div>
          <h2 className="section-title font-display">A Lifestyle <span className="italic text-[#B8893C]">Worth Returning</span> To.</h2>
          <p className="mt-6 text-[#3a322a] max-w-2xl mx-auto leading-relaxed">
            From the signature water-feature arrival to sky-level wellness clubs — every Tamra address is engineered to feel like a quiet retreat from the city.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {amenities.map((a, i) => (
            <div
              key={a.id}
              className="group relative aspect-[4/5] overflow-hidden bg-[#F5EFE6] cursor-pointer"
              onMouseEnter={() => setHover(i)}
              onMouseLeave={() => setHover(null)}
            >
              <img src={a.image} alt={a.name} className="w-full h-full object-cover img-hover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1F1B17]/90 via-[#1F1B17]/20 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col justify-end p-8 text-[#F5EFE6]">
                <div className="text-[10px] tracking-[0.5em] uppercase text-[#B8893C] mb-2">0{i + 1}</div>
                <div className="font-display text-2xl md:text-3xl tracking-[0.05em]">{a.name}</div>
                <div className={`h-px bg-[#B8893C] mt-4 transition-all duration-700 ${hover === i ? "w-24" : "w-8"}`}></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
